import { render, staticRenderFns } from "./AddressOption.vue?vue&type=template&id=3e19ff3a&"
import script from "./AddressOption.vue?vue&type=script&lang=ts&"
export * from "./AddressOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports